import { Task } from '@lit-labs/task';
import { request } from '../request.js';
import { TaskController } from './task.js';
import alertError from '../../html/alert-error.js';
import spinner from '../../html/spinner.js';

/**
 * @typedef {import('lit').LitElement} LitElement
 */

const PAGE_SIZE = 10;

export class ConnectAccountsController extends TaskController {
  /**
   * @param {LitElement} host
   * @param {Function} [filter]
   */
  constructor(host, filter) {
    super();

    this.host = host;
    this.results = null;
    this.search = null;
    this.page_index = 0;
    this.task = new Task(
      host,
      async () => {
        const query = {
          offset: String(this.page_index * PAGE_SIZE)
        };
        if (this.search) {
          query.search = this.search;
        }
        const query_string = new URLSearchParams(query).toString();
        const res = await request('GET', `/connect-accounts?${query_string}`);
        const total = Number(res.total);
        this.results = {
          accounts: filter ? res.list.filter(filter) : res.list,
          total: Number.isFinite(total) ? total : 0
        };
        return this.results;
      },
      () => []
    );
  }

  get pagination() {
    return {
      page_index: this.page_index,
      page_count: this.results ? Math.ceil(this.results.total / PAGE_SIZE) : 0
    };
  }

  setPage(page) {
    if (page === this.page_index) {
      return;
    }
    this.page_index = page;
    this.task.run();
  }

  setSearch(search) {
    if (search === this.search) {
      return;
    }

    this.search = search;
    this.page_index = 0;
    if (search.length !== 1) {
      this.task.run();
    }
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  setSpinnerTimeout() {
    if (this.timeout) {
      return;
    }
    this.timeout = setTimeout(() => {
      this.results = null;
      this.host.requestUpdate();
    }, 250);
  }

  render(complete) {
    return this.task.render({
      pending: () => {
        if (this.results) {
          this.setSpinnerTimeout();
          return complete(this.results);
        }

        return spinner();
      },

      error: alertError,

      complete: (results) => {
        this.clearTimeout();

        return complete(results);
      }
    });
  }
}
